import { getLocale } from "../runtime";

const sv_nocountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Norway`
};

const nocountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_nocountryenglish(inputs)
	return "noCountryEnglish";
};

export { nocountryenglish as "noCountryEnglish" };